import { useCallback } from 'react';
import { IInsuranceInfo, IInsuranceItem } from '@/types';
import { useCommonParams, useLoading } from '@/hooks';
import { clickEventHandler } from '@/helpers';
import { Wrapper } from '@/components/templates/collectInsuranceList/CollectInsuranceList.styled';
import { InsuranceListItem } from '@/components/organisms';
import { IntersectionObserver } from '@/components/common';
import { COMPONENT_TYPE } from '@/const';

const CollectInsuranceList = (props: IInsuranceInfo) => {
  const { ads = [] } = props;
  const commonParams = useCommonParams();
  const [, setLoading] = useLoading();

  const handleClick = useCallback(
    async (item: IInsuranceItem) => {
      await clickEventHandler({
        ...item,
        ...commonParams,
        setLoading,
        componentName: COMPONENT_TYPE.INSURANCE,
      });
    },
    [commonParams, setLoading],
  );

  const renderComponent = (item: IInsuranceItem, index: number) => (
    <IntersectionObserver key={index} {...item} componentName={COMPONENT_TYPE.INSURANCE}>
      <InsuranceListItem  page={commonParams.page} {...item} onClick={() => handleClick(item)} />
    </IntersectionObserver>
  );

  return (
    <Wrapper>
      {ads.length > 0 &&
        ads.map((item: IInsuranceItem, index: number) => renderComponent(item, index))}
    </Wrapper>
  );
};
export default CollectInsuranceList;
